import { ChangeDetectionStrategy, Component } from '@angular/core';
import { combineLatest, map } from 'rxjs';

import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-language-dropdown',
  templateUrl: './language-dropdown.component.html',
  styleUrls: ['./language-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageDropdownComponent {
  lang$ = combineLatest([this.userService.langCodes, this.userService.selectedLangCode]).pipe(
    map(([langCodes, langCode]) => langCodes.find((l) => l.code === langCode)),
  );

  constructor(private userService: UserService) {}
}
